import ConnectedBarCharts from './ConnectedBarCharts';

export default {
  id: 'ai-charts',
  getPanelModule() {
    return {
      menuOptions: [
        { icon: 'star', label: '质控示教', target: 'demo', from: 'right' },
        {
          icon: 'list',
          label: '影像评价',
          target: 'charts-panel',
          from: 'right',
        },
      ],
      components: [{ id: 'charts-panel', component: ConnectedBarCharts }],
      defaultContext: ['VIEWER'],
    };
  },
};
